import { render, staticRenderFns } from "./MemberManage.vue?vue&type=template&id=65efc47c&scoped=true&"
import script from "./MemberManage.vue?vue&type=script&lang=js&"
export * from "./MemberManage.vue?vue&type=script&lang=js&"
import style0 from "./MemberManage.vue?vue&type=style&index=0&id=65efc47c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65efc47c",
  null
  
)

export default component.exports